<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="任务进度"
      width="1200px"
      class="adaptationModal">
    <Table border :columns="columns" :loading="contentLoading" :data="tableData">
      <template slot="action" slot-scope="{ row }">
        <el-button type="primary" :disabled="row.status !== 10 || userId !== row.memberId" @click="startHandle(row)">开工</el-button>
        <el-button type="primary" :disabled="row.status !== 20 || userId !== row.memberId" @click="finishHandle(row)">完工</el-button>
        <el-button type="primary" @click="$refs.attachmentPage.open(row)">附件</el-button>
      </template>
      <template slot="percent" slot-scope="{ row, index }">
        <el-input
            v-model="row.completePercent"
            class="inputBox"
            :disabled="row.status !== 20 || userId !== row.memberId"
            @blur="percentInput(row, index)"/>
      </template>
      <template slot="note" slot-scope="{ row, index }">
        <el-input
            v-model="row.completeDesc"
            :disabled="userId !== row.memberId"
            type="textarea"
            autosize
            @blur="$set(tableData, index, row)"/>
      </template>
    </Table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <attachment-list ref="attachmentPage" @save-success="getData(taskId)"/>
  </el-dialog>
</template>

<script>
  import AttachmentList from "./AttachmentList.vue";
  export default {
    components: { AttachmentList },
    data() {
      return {
        submitLoading: false,
        contentLoading: false,
        dialogVisible: false,
        tableData: [],
        taskId: "",
        userId: JSON.parse(localStorage.getItem("mes_user_info")).userId,
        columns: [
          {
            title: "姓名",
            key: "memberName",
            width: 80,
            align: "center",
          },
          {
            title: "任务状态",
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
            title: "开始时间",
            key: "beginTime",
            width: 160,
            align: "center",
          },
          {
            title: "结束时间",
            key: "endTime",
            width: 160,
            align: "center",
          },
          {
            title: "附件数量",
            key: "attachmentCount",
            width: 90,
            align: "center",
          },
          {
            title: "进度(%)",
            key: "completePercent",
            slot: "percent",
            align: "center",
            width: 90,
          },
          {
            title: "备注",
            key: "completeDesc",
            slot: "note",
          },
          {
            title: "操作",
            slot: "action",
            width: 190,
            align: "center",
          },
        ],
      };
    },

    methods: {
      open(pkId) {
        this.dialogVisible = true;
        this.taskId = pkId;
        this.getData(pkId);
      },

      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `tasks/${pkId}`)
          .then((resp) => {
            if (resp.success) {
              resp.data.memberList.forEach((item) => {
                item.projectName = resp.data.projectName;
                item.taskName = resp.data.taskName;
                item.completePercent = item.completePercent ? item.completePercent : 0;
              });
              this.tableData = resp.data.memberList;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 开工  任务状态为未开工  并且姓名为当前用户
      startHandle(row) {
        this.$confirm("确认开工吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", `taskMembers/startTask/${row.pkId}`).then((resp) => {
            if (resp.success) {
              this.$message.success("任务已开工");
              this.dialogVisible = false;
              this.$emit("save-success");
            }
          });
        });
      },

      // 完工 任务状态为已开工  并且姓名为当前用户
      finishHandle(row) {
        this.$confirm("确认完工吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", `taskMembers/completeTask/${row.pkId}`).then((resp) => {
            if (resp.success) {
              this.$message.success("任务已完工");
              this.dialogVisible = false;
              this.$emit("save-success");
            }
          });
        });
      },

      handleSubmit() {
        this.$http.post("basic", "taskMembers/saveCompletePercent", this.tableData).then((resp) => {
          if (resp.success) {
            this.$message.success("任务进度更新成功");
            this.dialogVisible = false;
            this.$emit("save-success");
          }
        });
      },

      percentInput(row, index) {
        const pattern = /^((\d|[123456789]\d)(\.\d+)?|100)$/;
        if (!pattern.test(row.completePercent)) {
          this.$confirm("请输入0-100的数字值", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$set(this.tableData, index, row);
        }
      },
    },
  };
</script>

<style>
.inputBox .el-input__inner {
  text-align: center;
}
.adaptationModal .ivu-table-cell-with-expand {
  height: 37px;
  line-height: 37px;
}
</style>
